import React from 'react';
import Layout from '../components/Layout';
import { Mail } from 'lucide-react';

const TermsOfService = () => {
    return (
        <Layout>
            <section className="py-20 bg-white dark:bg-slate-950 transition-colors duration-500">
                <div className="container mx-auto px-4 max-w-4xl">
                    
                    {/* Header */}
                    <div className="mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
                            Terms of <span className="text-accent">Service</span>
                        </h1>
                        <p className="text-slate-500 dark:text-slate-400">
                            Last updated: Tue 3 Feb, 2026
                        </p>
                    </div>

                    {/* Content */}
                    <div className="prose prose-slate dark:prose-invert max-w-none">
                        <p className="text-lg text-slate-600 dark:text-slate-300 leading-relaxed mb-8">
                            These Terms govern access to and use of EverestCloud services.
                        </p>

                        <TermsSection title="Service Scope">
                            <p>
                                EverestCloud provides cloud infrastructure, platform services, and related solutions on a subscription or contractual basis. Specific service details are defined in individual agreements or order forms.
                            </p>
                        </TermsSection>

                        <TermsSection title="Acceptable Use">
                            <p>Customers agree to:</p>
                            <ul>
                                <li>Use services only for lawful purposes</li>
                                <li>Maintain the confidentiality of access credentials</li>
                                <li>Comply with applicable laws, regulations, and industry standards</li>
                            </ul>
                            <p>EverestCloud reserves the right to suspend access for misuse or security risk.</p>
                        </TermsSection>

                        <TermsSection title="Availability">
                            <p>
                                EverestCloud is designed for high availability; however, services may occasionally be unavailable due to maintenance, upgrades, or events beyond reasonable control.
                            </p>
                        </TermsSection>

                        <TermsSection title="Security & Responsibility">
                            <ul>
                                <li>EverestCloud secures the underlying platform</li>
                                <li>Customers are responsible for their workloads, data, and configurations unless otherwise agreed</li>
                                <li>Shared responsibility applies based on service type</li>
                            </ul>
                        </TermsSection>

                        <TermsSection title="Intellectual Property">
                            <p>
                                All platform technology, branding, and documentation remain the property of EverestCloud or its licensors.
                            </p>
                        </TermsSection>

                        <TermsSection title="Limitation of Liability">
                            <p>
                                EverestCloud is not liable for indirect, incidental, or consequential damages. Liability is limited to the extent permitted by law and governed by contractual terms.
                            </p>
                        </TermsSection>

                        <TermsSection title="Governing Law">
                            <p>
                                These Terms are governed by the laws of Nepal unless otherwise specified in a separate agreement.
                            </p>
                        </TermsSection>

                        {/* Contact */}
                        <div className="mt-12 p-6 bg-slate-50 dark:bg-slate-900/50 rounded-xl border border-slate-200 dark:border-white/5">
                            <div className="flex items-center gap-3">
                                <div className="p-3 bg-accent/10 rounded-lg">
                                    <Mail className="w-5 h-5 text-accent" />
                                </div>
                                <div>
                                    <p className="text-sm text-slate-500 dark:text-slate-400">Contact</p>
                                    <a href="mailto:info@everestcloud.com.np" className="text-accent hover:underline font-medium">
                                        info@everestcloud.com.np
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

const TermsSection = ({ title, children }) => (
    <div className="mb-8">
        <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4 flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-accent rounded-full"></span>
            {title}
        </h2>
        <div className="text-slate-600 dark:text-slate-300 leading-relaxed space-y-3 pl-4">
            {children}
        </div>
    </div>
);

export default TermsOfService;
